import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import Restructuration from "@/pages/Restructuration";
import FusionAcquisition from "@/pages/FusionAcquisition";
import DataRoom from "@/pages/DataRoom";
import CookieBanner from "@/components/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
          <Route path="/restructuration-retournement" element={<Restructuration />} />
          <Route path="/fusion-acquisition" element={<FusionAcquisition />} />
          <Route path="/data-room" element={<DataRoom />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      <CookieBanner />
    </div>
  );
}

export default App;
